<template>
  <div>
    <div class=" head h-14rem">
      <div class="flex flex-col justify-center items-center space-y-4">
        <div class="
                grid grid-cols-[auto,auto] grid-rows-[auto,auto]
                justify-items-start
                gap-x-10 gap-y-2
              ">
          <el-avatar :size="100" icon="el-icon-user-solid" class="row-span-2" :src="user.icon"></el-avatar>
          <p class="font-medium mt-auto whitespace-nowrap">{{ user.name }}</p>

          <p class="text-gray-400 text-sm">
            ID:
            <span>{{ user.id }}</span>
          </p>
        </div>
        <p class="space-x-18 flex flex-nowrap">
          <el-link type="info" :underline="false" @click="editData" class="whitespace-nowrap">{{ $t("编辑资料") }}</el-link>
          <el-link type="info" :underline="false" @click="changePsw" class="whitespace-nowrap">{{ $t("修改密码") }}</el-link>
        </p>
      </div>
      <div class="flex items-center justify-between  flex-nowrap text h-full w-full pl-12 pr-18">
        <el-badge :value="item.badge" type="primary" v-for="item in orderState" :key="item.id" :hidden="item.badge == 0">
          <router-link :to="item.url">
            <span class="iconfont" :class="item.icon"></span>
            <p >
              {{ $t(item.title) }}
            </p>
          </router-link>
        </el-badge>
      </div>
    </div>
    <p class="h-4 bg-mainGray -mx-8 mt-8"></p>
    <div id="favorite" class="pt-4">
      <div class="flex justify-between items-center">
        <div>{{ $t("我的收藏") }}</div>
        <div>
          <el-link type="info" :underline="false">
            <router-link :to="{ name: 'Favorite' }">{{
              $t("查看更多")
            }}</router-link>

            <span class="
                    iconfont
                    icon-right
                    text-gray-400
                    inline-block
                    transform
                    translate-y-1px
                  "></span>
          </el-link>
        </div>
      </div>
      <el-divider direction="horizontal" class=""></el-divider>

      <div v-if="dataLength">
        <List :span="5" :data="data" #default="{ item }">
          <FavoriteItem :item="item" @del="del" @add="add"></FavoriteItem>
        </List>
      </div>
      <div v-else class="mt-30">
        <img :src="require(`@/assets/image/暂无收藏.png`)" class="m-auto" />
      </div>
    </div>
    <!-- 编辑资料dialog -->
    <el-dialog :title="$t('编辑资料')" :visible.sync="centerDialogVisible" width="35%" center destroy-on-close>
      <EditData :data="user" @save_message="saveMessage" @changeCancel="centerDialogVisible = false"></EditData>
    </el-dialog>
    <!-- 修改密码dialog -->
    <el-dialog :title="$t('修改密码')" :visible.sync="pswDialogVisable" width="30%" center destroy-on-close>
      <!--  @changeSuc="changeSuc"
        @changeCancel="pswDialogVisable = false" -->
      <ChangePsdTab></ChangePsdTab>
    </el-dialog>
  </div>
</template>

<script>
import bus from "@/API/util/bus.js";
import List from "@/components/base/list.vue";
import FavoriteItem from "@/components/base/favoriteItem.vue";
import EditData from "@/components/mine/personalMessage/editData.vue";

import ChangePsdTab from "@/components/mine/personalMessage/changePsdTab.vue";
import { computed, onMounted, ref, watchEffect } from "@vue/composition-api";
import { equals, prop, reject } from "ramda";
export default {
  components: { List, FavoriteItem, EditData, ChangePsdTab },
  setup(props, ctx) {
    const user = computed(() => ctx.root.$store.getters.user);

    const data = ref();
    const dataLength = computed(() =>
      data?.value?.items?.length ? data.value.items : 0
    );
    const saveMessage = () => {
      centerDialogVisible.value = false;
    };
    const flight_id = ref();

    //  订单状态
    //请求订单
    const unpay = ref();
    const uncomment = ref();

    (async () => {
      unpay.value = (
        await ctx.root.$callapi("user/getOrderList", {
          tag: "unpay",
        })
      ).data.total;
    })();
    (async () => {
      uncomment.value = (
        await ctx.root.$callapi("user/getOrderList", {
          tag: "uncomment",
        })
      ).data.total;
    })();
    const orderState = ref();
    watchEffect(() => {
      orderState.value = [
        {
          id: 1,
          title: "待付款",
          url: { name: "OrderList", query: { q: "unpay" } },
          icon: " icon-daifukuan",
          badge: unpay.value,
        },
        {
          id: 2,
          title: "待发货",
          url: { name: "OrderList", query: { q: "unsent" } },
          icon: "icon-daifahuo",
        },
        {
          id: 3,
          title: "待收货",
          url: { name: "OrderList", query: { q: "sent" } },
          icon: "icon-daishouhuo",
        },
        {
          id: 4,
          title: "待评价",
          url: { name: "OrderList", query: { q: "uncomment" } },
          icon: "icon-pinglun",
          badge: uncomment.value,
        },
        {
          id: 5,
          title: "退款售后",
          url: { name: "OrderList", query: { q: "cancel" } },
          icon: "icon-shouhou",
        },
        {
          id: 6,
          title: "全部订单",
          url: { name: "OrderList", query: { q: "all" } },
          icon: "icon-quanbudingdan",
        },
      ];
    });

    onMounted(async () => {
      ctx.root.$doing()
      const res = await ctx.root.$callapi("user/getCollectedList", {
        tag: "product",
        page: 1,
        size: 5,
      });
      ctx.root.$done()
      data.value = res.data;
      // flight_id.value = (await ctx.root.$callapi("getDefaultFlight")).data.id;
    });

    const del = async (e) => {
      await ctx.root.$callapi("user/doCollect", {
        model: "product",
        objid: e,
        action: "cancel",
      });
      data.value.items = reject((v) => equals(prop("objid")(v))(e))(
        prop("items")(data.value)
      );
      // dataLength.value = data.value.items.length;
    };

    const add = (e) => {
      const cart_info = computed(() => {
        return ctx.root.$store.state.cart.cart;
      });
      const in_cart = cart_info.value
        .map((item) => item.product.id)
        .filter((item) => item == e);
      const res = in_cart.length
        ? ctx.root.$toast(ctx.root.$t("商品已存在购物车"), "warning")
        : (async () => {
          await ctx.root.$callapi("trade/editWithCart", {
            pid: e,
            quantity: 1,
          });
          const r = await ctx.root.$callapi("trade/getMyCartList");
          ctx.root.$store.commit("SAVE_CART", r.data);
          ctx.root.$toast(ctx.root.$t("已添加购物车"), "success");
        })();
    };
    const centerDialogVisible = ref(false);
    const editData = () => {
      centerDialogVisible.value = true;
    };
    const display = ref(true);
    const handleClose = () => {
      // centerDialogVisible.value = false
    };
    //修改密码
    const pswDialogVisable = ref(false);
    // const bindPhoneNum = computed(() => ctx.root.$store.getters.user.phone);
    const changePsw = () => {
      pswDialogVisable.value = true;
    };
    bus.on("changeSuccess", () => {
      pswDialogVisable.value = false;
    });
    bus.on("changeCancel", () => {
      pswDialogVisable.value = false;
    });
    return {
      user,
      data,
      del,
      add,
      dataLength,
      editData,
      centerDialogVisible,
      saveMessage,
      handleClose,
      display,
      changePsw,
      pswDialogVisable,
      orderState,
      unpay,
      uncomment,
      // bindPhoneNum,
    };
  },
};
</script>
<style scoped lang="scss">.text {
  border-left: 0.1rem solid #eeeeee;
}
.text span {
  display: inline-block;
  margin-bottom: 1rem;
  --tw-text-opacity: 1;
  color: rgba(21, 186, 99, var(--tw-text-opacity));
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-translate-z: 0;
  --tw-rotate: 0;
  --tw-rotate-x: 0;
  --tw-rotate-y: 0;
  --tw-rotate-z: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-scale-z: 1;
  -webkit-transform: translateX(var(--tw-translate-x)) translateY(var(--tw-translate-y)) translateZ(var(--tw-translate-z)) rotate(var(--tw-rotate)) rotateX(var(--tw-rotate-x)) rotateY(var(--tw-rotate-y)) rotateZ(var(--tw-rotate-z)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) scaleZ(var(--tw-scale-z));
  -ms-transform: translateX(var(--tw-translate-x)) translateY(var(--tw-translate-y)) translateZ(var(--tw-translate-z)) rotate(var(--tw-rotate)) rotateX(var(--tw-rotate-x)) rotateY(var(--tw-rotate-y)) rotateZ(var(--tw-rotate-z)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) scaleZ(var(--tw-scale-z));
  transform: translateX(var(--tw-translate-x)) translateY(var(--tw-translate-y)) translateZ(var(--tw-translate-z)) rotate(var(--tw-rotate)) rotateX(var(--tw-rotate-x)) rotateY(var(--tw-rotate-y)) rotateZ(var(--tw-rotate-z)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) scaleZ(var(--tw-scale-z));
  --tw-scale-x: 2.5;
  --tw-scale-y: 2.5;
  --tw-scale-z: 2.5;
}
.text>div {
  cursor: pointer;
}
.head {
  display: grid;
  grid-template-columns: 1.2fr 3fr;
}</style>
